/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_MovingInputs */

const en_ui_more_stats_moving = /** @type {(inputs: Ui_More_Stats_MovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving time`)
};

const de_ui_more_stats_moving = /** @type {(inputs: Ui_More_Stats_MovingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bewegung`)
};

/**
* | output |
* | --- |
* | "Moving time" |
*
* @param {Ui_More_Stats_MovingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_moving = /** @type {((inputs?: Ui_More_Stats_MovingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_MovingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_moving(inputs)
	return de_ui_more_stats_moving(inputs)
});